import { Button } from '@massilia/ui'
import { Download, Loader2, Printer } from 'lucide-react'
import { toast } from 'sonner'

interface PaymentReceiptActionsProps {
  isLoading: boolean
  onDownload: () => Promise<Blob>
}

export function PaymentReceiptActions({ isLoading, onDownload }: PaymentReceiptActionsProps) {
  const handle = async (action: 'download' | 'print') => {
    try {
      const blob = await onDownload()
      const url = window.URL.createObjectURL(blob)
      if (action === 'print') {
        window.open(url, '_blank')
      } else {
        const a = document.createElement('a')
        a.href = url
        a.download = 'recu-paiement.pdf'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
      setTimeout(() => window.URL.revokeObjectURL(url), 1000)
    } catch {
      toast.error('Erreur lors de la récupération du reçu')
    }
  }

  return (
    <>
      <Button
        disabled={isLoading}
        onClick={() => handle('print')}
        type="button"
        variant="outline"
      >
        {isLoading ? <Loader2 className="size-4 animate-spin" /> : <Printer className="size-4" />}
        Imprimer le reçu
      </Button>
      <Button
        disabled={isLoading}
        onClick={() => handle('download')}
        type="button"
        variant="outline"
      >
        {isLoading ? <Loader2 className="size-4 animate-spin" /> : <Download className="size-4" />}
        Télécharger le reçu
      </Button>
    </>
  )
}
